export enum FrequentServicesIdEnum {
  TOPUP = 0,
  BUNDLE = 1,
  C2C = 2,
  BILL = 3,
  TAXI = 4,
  TRAFFIC_FINES = 5,
  TOLL = 6,
  CHARITY = 7,
  CREDIT = 8,
  BNPL = 9,
  // INSURANCE = 10,
  WEALTH = 11,
  BARCODE_SCANNER = 12,
  WALLET = 13,
  PAYMENT_OF_INSTALLMENT = 14,
  INSTALLMENT_PURCHASE_WITH_CHECK = 15,
  MCI_MOBILE_BILL = 16,
  MTN_MOBILE_BILL = 17,
  RIGHTEL_MOBILE_BILL = 18,
  INVESTMENT_FUNDS = 19,
  // GOLD_FUNDS = 20,
  MOLTEN_GOLD_FUNDS = 21,
  CROWDFUNDING = 22,
  THIRD_PARTY_INSURANCE = 23,
  CAR_BODY_INSURANCE = 24,
  ELECTRICAL_DEVICES_INSURANCE = 25,
  REAL_ESTATE_INVESTMENT = 26,
}
